<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
     
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter" style="background-image: linear-gradient(90deg, rgb(157, 207, 234), rgb(157, 207, 234));">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center text-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto w-full">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="px-8 pt-8 register-tabs-container">
                                <div class="vx-card__title mb-10">
                                    <h4 class="mb-4">注册账号</h4>
                                    <p>填写下列信息注册一个新账号.</p>
                                </div>
                                <register-jwt></register-jwt>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import RegisterJwt from "./RegisterJWT.vue"

export default {
    components: {
      RegisterJwt,
    },
    async mounted() {
        if (await this.$s.auth.isLogin()) {
            this.$s.auth.loginSuccess(this.$s.auth.user, this)
        }
    },
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
